import { forwardRef, useState } from 'react';
import { CarregarMotAvui, VeureMotsEncreuatsAnteriors, ComprovarMotsEncreuats, ResoldreMotsEncreuats, ReiniciarMotsEncreuats } from '../../Actions.js';
import { get_day_today } from '../../utils.js';

const Options = forwardRef((props, ref) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        open ? handleClose() : setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="options">
            <img className="h-[20px]" src={process.env.REACT_APP_ASSETSDIR + 'options.png'} alt="" onClick={handleClick}></img>
            <div hidden={!open} onClick={handleClose} onClose={handleClose} className="option-menu">
                <div onClick={handleClose}>
                    <div className="relative w-full">
                        <ul className="text-[16px] md:text-[15px] whitespace-normal">
                            <li onClick={() => {
                                handleClose();
                            }}>
                                {props.crosswordData.date === get_day_today(props.crosswordData.date) || !props.crosswordData.date ?
                                    <div onClick={() => {
                                        VeureMotsEncreuatsAnteriors(props.setCrosswordData, ref, props.setOnce)
                                    }}>Minimots anteriors
                                    </div> :
                                    <div onClick={() => {
                                        CarregarMotAvui(props.setCrosswordData, ref, props.setOnce)
                                    }}>Minimot d'avui
                                    </div>
                                }
                            </li>
                            <li onClick={() => {
                                ComprovarMotsEncreuats();
                                handleClose();
                            }}>Comprovar</li>
                            <li onClick={() => {
                                ResoldreMotsEncreuats(ref);
                                handleClose();
                            }}>Resoldre</li>
                            <li onClick={() => {
                                ReiniciarMotsEncreuats(ref);
                                handleClose();
                            }}>Reiniciar</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
})
export default Options;
